enum FitAssistantVariation {
  None,
  Awnings,
  BikeAdapters,
  CarRoofRacks,
  CarSeats,
  DogCrates,
  RoofPlatforms,
  RooftopTents,
  TruckBedBikeRacks,
  TruckRackSystem,
  TruckAndSpareTireBikeRacks,
  VanRackSystems,
}

export default FitAssistantVariation;
